//
// ─── IMPORT ───────────────────────────────────────────────────────────────
//
import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import BootstrapVue from "bootstrap-vue";
import VueI18n from "vue-i18n";
import localeMsg from "./locale/locale";
import VueMeta from "vue-meta";

const VueAnime = require("vue-animejs");
import "./assets/fonts/all.min.js";

//
// ─── USE ──────────────────────────────────────────────────────────────────
//
Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VueAnime);
Vue.use(VueMeta);

//
// ─── CONFIG ───────────────────────────────────────────────────────────────
//
Vue.config.productionTip = process.env.NODE_ENV == "production" ? false : true;
const i18n = new VueI18n({
  locale: "en",
  messages: localeMsg
});

//
// ─── INJECTION ──────────────────────────────────────────────────────────────────
//
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
